import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from '@askporter/config-provider';
import { Button, Typography } from '../..';
import { PaginationProps } from './Table.types';

// Pagination Component
export const TablePagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  disableNext,
  disablePrevious,
}) => {
  const { t } = useTranslation();
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (!totalPages) {
      if (disableNext) return;
      onPageChange(currentPage + 1);
    } else if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const nextDisabled = totalPages ? currentPage >= totalPages : disableNext;
  const previousDisabled = totalPages === undefined ? disablePrevious : currentPage <= 1;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
        width: '100%',
      }}
    >
      {totalPages && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Typography style={{ fontSize: '14px', color: '#475467', userSelect: 'none' }}>
            {t('common:pagination:current_page:label', { currentPage, totalPages })}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Button
          color="secondary"
          variant="contained"
          size="small"
          onClick={handlePrevious}
          disabled={previousDisabled}
          startIcon={<ChevronLeft />}
        >
          {t('common:pagination:previous_page:button')}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          size="small"
          onClick={handleNext}
          disabled={nextDisabled}
          endIcon={<ChevronRight />}
        >
          {t('common:pagination:next_page:button')}
        </Button>
      </Box>
    </Box>
  );
};
